import { billing, unwrap } from "../api";
import type { BillingComponents } from "@steelyard/api-client";

/** Ported from apps/admin/app/(app)/settings/applicability/page.tsx, through the generated billing client. */
export type ApplicabilityAnswer = BillingComponents["schemas"]["ApplicabilityResponse"];

export async function getApplicability(invoiceId: string) {
  return unwrap(
    (await billing()).GET("/api/billing/registration/applicability", { params: { query: { invoiceId } } }),
  );
}

/** The two statutory figures (null is unset: nothing qualifies, never zero) and the registered states' two-digit codes. */
export type Thresholds = { eInvoiceThreshold: number | null; ewayBillConsignmentValue: number | null; registeredStates: string[] };

const asNumber = (v: unknown) => (v === null || v === undefined ? null : Number(v));

export async function getThresholds(): Promise<Thresholds> {
  const t = await unwrap((await billing()).GET("/api/billing/registration/thresholds"));
  return { eInvoiceThreshold: asNumber(t.eInvoiceThreshold), ewayBillConsignmentValue: asNumber(t.ewayBillConsignmentValue), registeredStates: t.registeredStates ?? [] };
}

export async function setThresholds(body: Thresholds): Promise<Thresholds> {
  const t = await unwrap((await billing()).PUT("/api/billing/registration/thresholds", { body }));
  return { eInvoiceThreshold: asNumber(t.eInvoiceThreshold), ewayBillConsignmentValue: asNumber(t.ewayBillConsignmentValue), registeredStates: t.registeredStates ?? [] };
}
